import type { TriggerOrderType } from '@/constants/advancedOrder';

import { TRADE_TYPE } from '@/utils/0x/history/status';

/** What a trade is shown as: its trade type, or its trigger order type when it has one. */
export type TradeKind = TRADE_TYPE | TriggerOrderType;

/**
 * Color per trade kind, shared by the history table's type dots and the
 * portfolio chart's markers so the two stay in step.
 */
export const TRADE_KIND_COLORS: Record<TradeKind, { className: string; cssVar: string }> = {
  [TRADE_TYPE.MARKET]: {
    className: 'bg-token-purple-1000',
    cssVar: 'var(--token-color-purple-1000)',
  },
  [TRADE_TYPE.MARKET_TRANSFER]: {
    className: 'bg-token-purple-1000',
    cssVar: 'var(--token-color-purple-1000)',
  },
  [TRADE_TYPE.CROSS_CHAIN]: {
    className: 'bg-special-trade-type-bridge',
    cssVar: 'var(--token-color-special-trade-type-bridge)',
  },
  [TRADE_TYPE.LIMIT]: {
    className: 'bg-token-orange-1100',
    cssVar: 'var(--token-color-orange-1100)',
  },
  'stop-loss': { className: 'bg-token-red-1000', cssVar: 'var(--token-color-red-1000)' },
  'take-profit': { className: 'bg-token-green-1000', cssVar: 'var(--token-color-green-1000)' },
};
